import React from "react";

export const HomeIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='-15 -10 280 200'
      className='nav-icon nav-icon-home'
    >
      <defs>
        <clipPath>
          <path
            fill='#fff'
            d='M24.946 83.065H376.466V191.165H24.946z'
            paintOrder='fill markers stroke'
          ></path>
        </clipPath>
      </defs>
      <path
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='12'
        d='M109 151.14c6.672-1.077 10.811-1.785 16.241-2.22 5.43-.435 18.031-.588 21.127-.306s7.275.57 10.794 1.483c1.07.277 2.245.481 3.095 1.201 1.825 1.546 2.145 2.817-1.445 4.062 0 0-.653.981-8.6.139-7.947-.843-16.182.08-22.106.05-5.923-.027-26.08 2.517-28.228 3.446-2.148.928-1.17-2.552-5.055 1.241-1.789 1.891-.564-.931 1.182-4.215.843-1.585-.848-.477.554-1.145 3.68-1.753 5.768-2.66 12.441-3.737z'
        paintOrder='fill markers stroke'
        transform='translate(0 32)'
      ></path>
      <path
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='12'
        d='M122.04 79.073c2.908-8.309 7.957-24.746 8.608-24.969.652-.222 2.395.563 2.73.955.335.39-3.315 16.92-5.364 25.288-2.382 9.722-3.208 14.848-8.049 28.92-4.841 14.072-20.373 50.127-20.373 50.127-1.7.08-5.155 3.14-5.055 1.241-1.98.858 13.27-40.779 17.87-54.442 4.6-13.663 6.464-18.065 9.633-27.12zM42.919 29.028s15.377-1.898 23.088-1.625c9.717.345 19.936.357 28.865 4.101 4.342 1.821 8.775 4.57 11.127 8.56 1.403 2.38 2.783 3.98 2.968 6.788.153 2.324-.777 5.834-.82 8.103-.103 5.453-1.176 10.934-2.952 16.107-3.078 8.966-7.432 17.668-13.158 25.307-4.21 5.616-9.48 10.555-15.254 14.649-3.603 2.554-7.45 5.378-11.86 6.015-11.338 1.64-24.706.622-33.801-6.167-8.224-6.139-10.537-17.597-13.444-27.274-1.866-6.211-2.311-12.8-2.418-19.27-.11-6.688.581-13.41 1.843-19.986.261-1.36.256-2.936 1.178-3.988 1.758-2.005 5.547-2.396 7.358-3.357 5.595-2.967 8.144-4.998 17.279-7.962l1.04 8.884c-4.786.821-9.869 1.499-13.699 4.313-1.87 1.374-4.375 1.32-5.082 3.493-1.998 6.138-3.035 14.127-2.835 20.562.164 5.274.857 12.07 2.302 17.155 1.842 6.483 5.175 18.233 10.525 22.494 8.259 6.58 21.707 7.208 32.17 4.48 3.246-.846 7.049-3.28 9.005-4.805 4.172-3.252 6.93-7.704 9.948-12.14 5.133-7.548 11.487-14.62 12.697-23.694.708-5.314 1.408-10.67 1.115-16.039-.19-3.495 1.34-5.795 1.568-9.855.219-3.917-5.357-6.187-9.003-7.865-2.978-1.37-6.482-1.265-9.771-1.454-5.22-.3-10.465.109-15.678.512-7.79.602-23.261 2.843-23.261 2.843zM220.78 29.802s-15.359-2.031-23.073-1.825c-9.72.26-19.938.183-28.9 3.85-4.358 1.783-8.815 4.492-11.201 8.461-1.423 2.368-2.818 3.956-3.027 6.763-.173 2.323.726 5.84.75 8.11.057 5.453 1.08 10.944 2.81 16.132 3.001 8.992 7.28 17.732 12.939 25.42 4.16 5.652 9.387 10.637 15.126 14.78 3.58 2.586 7.402 5.443 11.808 6.119 11.323 1.738 24.7.836 33.853-5.873 8.277-6.067 10.69-17.505 13.68-27.156 1.92-6.195 2.423-12.78 2.586-19.248.169-6.687-.465-13.416-1.67-20.002-.248-1.362-.23-2.938-1.142-3.998-1.74-2.02-5.526-2.445-7.329-3.42-5.569-3.017-8.1-5.07-17.209-8.113l-1.117 8.874c4.78.863 9.856 1.585 13.661 4.432 1.858 1.39 4.363 1.359 5.052 3.538 1.944 6.154 2.912 14.153 2.656 20.586-.21 5.271-.962 12.062-2.451 17.134-1.899 6.466-5.333 18.187-10.72 22.402-8.316 6.507-21.77 7.019-32.206 4.2-3.24-.875-7.021-3.342-8.964-4.883-4.144-3.288-6.863-7.764-9.842-12.226-5.067-7.593-11.36-14.72-12.49-23.803-.662-5.32-1.316-10.682-.976-16.048.22-3.493-1.29-5.807-1.482-9.869-.185-3.918 5.41-6.14 9.07-7.786 2.991-1.345 6.494-1.209 9.785-1.37 5.222-.255 10.464.2 15.673.649 7.784.67 23.235 3.045 23.235 3.045z'
        paintOrder='fill markers stroke'
        transform='translate(0 32)'
      ></path>
      <path
        fill='none'
        stroke='#000'
        strokeLinecap='round'
        strokeWidth='13'
        d='M105.06 41.365s28.365-19.384 53.545-.418'
        transform='translate(0 32)'
      ></path>
      <path
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='12'
        d='M248.53-2.806c-.3-3.526-10.279-5.098-15.706-6.85-6.808-2.2-15.49-3.934-20.955-4.542-5.465-.607-8.1-.467-11.561-.09-3.462.375-5.956 1.237-8.88 2.076-2.139.614-4.21 1.453-6.322 2.161-2.653.89-5.903 1.75-8.044 2.43-2.142.678-2.924.95-4.757 1.78-1.833.832-2.449 1.982-6.028 3.56-1.396.616-6.527 6.811-4.536 9.794.172.258-.744.357.915-.066 3.034-.773 8.941-4.552 11.462-6.163 2.52-1.612 2.692-1.372 4.601-2.522 1.91-1.15 5.231-2.374 8.004-3.367 1.966-.704 3.982-1.64 6.019-2.329 2.706-.914 5.382-2.172 8.224-2.386 3.287-.248 6.627.41 9.805 1.303 6.432 1.808 12.299 5.29 18.376 8.103 5.512 2.552 15.829 9.23 16.397 7.956.57-1.274 3.287-7.322 2.987-10.848zM7.223 6.12c-.16-3.535 9.525-6.454 14.676-8.932 6.462-3.108 14.841-6.01 20.179-7.358 5.337-1.348 7.967-1.568 11.447-1.668 3.48-.099 6.064.414 9.07.847 2.2.317 4.363.866 6.548 1.28 2.744.52 6.076.93 8.287 1.31 2.211.38 3.02.543 4.946 1.117 1.925.574 2.685 1.63 6.437 2.705 1.464.42 7.353 5.86 5.768 9.088-.137.28.783.252-.915.06-3.107-.353-9.453-3.292-12.16-4.546-2.707-1.253-2.846-.992-4.888-1.871-2.042-.88-5.493-1.64-8.37-2.245-2.04-.43-4.16-1.083-6.268-1.488-2.8-.537-5.617-1.418-8.461-1.243-3.29.202-6.515 1.31-9.549 2.63-6.14 2.668-11.506 6.913-17.159 10.537-3.764 2.413-9.78 6.45-11.155 7.457-.382.28-7.671 8.269-8.325 7.079-1.249-2.275.324-12.502-.107-14.758z'
        paintOrder='fill markers stroke'
        transform='translate(0 32)'
      ></path>
      <path
        d='M280.57-335.67c5.608-.91 9.087-1.506 13.652-1.883s15.164-.548 17.769-.327c2.605.221 6.12.443 9.084 1.18.9.224 1.89.388 2.607.977 1.542 1.264 1.815 2.307-1.2 3.344 0 0-.546.809-7.233.145-6.687-.664-13.61.123-18.593.12-4.982-.001-21.927 2.163-23.73 2.934s-.994-2.093-4.247 1.039c-1.498 1.56-.478-.764.979-3.47.703-1.305-.715-.389.462-.943 3.089-1.454 4.842-2.207 10.45-3.116z'
        paintOrder='fill markers stroke'
        transform='translate(0 32)'
      ></path>
      <path
        d='M291.27-394.97c2.416-6.84 6.602-20.371 7.15-20.556.547-.185 2.015.454 2.299.775.283.32-2.727 13.922-4.42 20.807-1.967 8-2.643 12.217-6.664 23.802-4.02 11.585-16.953 41.279-16.953 41.279-1.429.07-4.324 2.6-4.247 1.039-1.662.712 11.011-33.57 14.831-44.818s5.371-14.873 8.004-22.33zM224.54-435.82s12.927-1.615 19.413-1.418c8.174.248 16.769.222 24.293 3.268 3.659 1.482 7.398 3.725 9.39 6.996 1.19 1.951 2.356 3.262 2.522 5.57.137 1.91-.632 4.799-.66 6.664-.068 4.483-.95 8.993-2.424 13.251-2.557 7.382-6.187 14.551-10.975 20.85-3.52 4.631-7.935 8.71-12.776 12.097-3.021 2.113-6.246 4.447-9.954 4.987-9.53 1.389-20.778.6-28.452-4.949-6.94-5.017-8.927-14.428-11.408-22.373-1.592-5.099-1.99-10.514-2.104-15.832-.116-5.497.44-11.027 1.478-16.436.214-1.118.203-2.414.976-3.282 1.47-1.655 4.656-1.99 6.176-2.786 4.695-2.46 6.832-4.138 14.504-6.607l.908 7.3c-4.024.692-8.296 1.267-11.506 3.594-1.568 1.136-3.676 1.1-4.263 2.89-1.657 5.052-2.5 11.624-2.309 16.913.157 4.334.765 9.918 2 14.094 1.572 5.322 4.418 14.969 8.934 18.454 6.97 5.379 18.284 5.847 27.073 3.567 2.727-.707 5.917-2.722 7.557-3.982 3.497-2.688 5.8-6.357 8.322-10.016 4.29-6.223 9.61-12.059 10.593-19.523.577-4.37 1.146-8.776.88-13.189-.173-2.872 1.106-4.769 1.283-8.107.17-3.22-4.528-5.067-7.601-6.433-2.51-1.116-5.457-1.017-8.225-1.16-4.391-.229-8.802.127-13.185.476-6.55.523-19.554 2.42-19.554 2.42zM374.14-435.82s-12.927-1.615-19.413-1.418c-8.174.248-16.769.222-24.293 3.268-3.659 1.482-7.398 3.725-9.39 6.996-1.19 1.951-2.356 3.262-2.522 5.57-.137 1.91.632 4.799.66 6.664.068 4.483.95 8.993 2.424 13.251 2.557 7.382 6.187 14.551 10.975 20.85 3.52 4.631 7.935 8.71 12.776 12.097 3.021 2.113 6.246 4.447 9.954 4.987 9.53 1.389 20.778.6 28.452-4.949 6.94-5.017 8.927-14.428 11.408-22.373 1.592-5.099 1.99-10.514 2.104-15.832.116-5.497-.44-11.027-1.478-16.436-.214-1.118-.203-2.414-.976-3.282-1.47-1.655-4.656-1.99-6.176-2.786-4.695-2.46-6.832-4.138-14.504-6.607l-.908 7.3c4.024.692 8.296 1.267 11.506 3.594 1.568 1.136 3.676 1.1 4.263 2.89 1.657 5.052 2.5 11.624 2.309 16.913-.157 4.334-.765 9.918-2 14.094-1.572 5.322-4.418 14.969-8.934 18.454-6.97 5.379-18.284 5.847-27.073 3.567-2.727-.707-5.917-2.722-7.557-3.982-3.497-2.688-5.8-6.357-8.322-10.016-4.29-6.223-9.61-12.059-10.593-19.523-.577-4.37-1.146-8.776-.88-13.189.173-2.872-1.106-4.769-1.283-8.107-.17-3.22 4.528-5.067 7.601-6.433 2.51-1.116 5.457-1.017 8.225-1.16 4.391-.229 8.802.127 13.185.476 6.55.523 19.554 2.42 19.554 2.42z'
        paintOrder='fill markers stroke'
        transform='translate(0 32)'
      ></path>
      <path
        fill='none'
        stroke='#000'
        strokeLinecap='round'
        strokeWidth='8'
        d='M276.85-425.9s23.787-16.036 45.035-.535'
        transform='translate(0 32)'
      ></path>
      <path
        d='M395.85-452.96c-.265-2.897-8.664-4.154-13.235-5.575-5.735-1.784-13.043-3.178-17.642-3.658s-6.814-.355-9.725-.034c-2.91.322-5.005 1.039-7.46 1.74-1.798.512-3.537 1.209-5.31 1.799-2.228.74-4.958 1.46-6.757 2.025-1.8.566-2.456.791-3.995 1.481s-2.052 1.638-5.057 2.948c-1.172.511-5.465 5.622-3.78 8.067.146.212-.624.296.77-.057 2.549-.647 7.504-3.774 9.618-5.108 2.114-1.333 2.258-1.137 3.86-2.09 1.603-.952 4.392-1.97 6.72-2.795 1.652-.586 3.343-1.363 5.054-1.936 2.273-.762 4.52-1.805 6.909-1.992 2.764-.215 5.575.314 8.252 1.037 5.416 1.463 10.364 4.305 15.485 6.595 4.645 2.078 13.347 7.53 13.82 6.482s2.738-6.031 2.473-8.929zM202.37-451.73c-.148-2.906 7.988-5.34 12.311-7.395 5.424-2.579 12.461-4.995 16.945-6.121 4.484-1.127 6.695-1.318 9.622-1.412 2.926-.094 5.101.319 7.632.664 1.851.253 3.672.696 5.511 1.028 2.31.418 5.115.743 6.976 1.048 1.86.305 2.542.435 4.164.9 1.621.465 2.264 1.33 5.424 2.201 1.232.34 6.206 4.791 4.885 7.45-.115.23.66.205-.77.052-2.615-.279-7.963-2.672-10.245-3.692-2.282-1.021-2.397-.806-4.118-1.522-1.721-.716-4.626-1.327-7.048-1.815-1.718-.346-3.503-.875-5.277-1.2-2.358-.432-4.73-1.147-7.122-.992-2.766.178-5.475 1.1-8.021 2.195-5.155 2.216-9.653 5.725-14.394 8.724-3.157 1.997-8.203 5.337-9.356 6.17-.32.231-6.422 6.825-6.976 5.848-1.059-1.865.227-10.279-.144-12.13z'
        paintOrder='fill markers stroke'
        transform='translate(0 32)'
      ></path>
    </svg>
  );
};

export const AboutIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      stroke='#000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.9'
      className='nav-icon nav-icon-about'
      viewBox='0 0 24 24'
    >
      <path stroke='none' d='M0 0h24v24H0z'></path>
      <circle cx='12' cy='12' r='9'></circle>
      <path d='M12 8L12.01 8'></path>
      <path d='M11 12L12 12 12 16 13 16'></path>
    </svg>
  );
};

export const WorksIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      stroke='#000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.9'
      className='nav-icon nav-icon-works'
      viewBox='0 0 24 24'
    >
      <path stroke='none' d='M0 0h24v24H0z'></path>
      <path d='M5 4h4l3 3h7a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2'></path>
    </svg>
  );
};

export const BytesIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      stroke='#000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.9'
      className='nav-icon nav-icon-bytes'
      viewBox='0 0 24 24'
    >
      <path stroke='none' d='M0 0h24v24H0z'></path>
      <path d='M7 8L3 12 7 16'></path>
      <path d='M17 8L21 12 17 16'></path>
      <path d='M14 4L10 20'></path>
    </svg>
  );
};

export const ContactIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      stroke='#000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.9'
      className='nav-icon nav-icon-contact'
      viewBox='0 0 24 24'
    >
      <path stroke='none' d='M0 0h24v24H0z'></path>
      <path d='M10 14L21 3'></path>
      <path d='M21 3l-6.5 18a.55.55 0 01-1 0L10 14l-7-3.5a.55.55 0 010-1L21 3'></path>
    </svg>
  );
};
